import { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  API,
  GlobalActions,
  NavigationHelper,
  TableIdentityProviders,
  viAdd,
  withRouter,
} from 'vibeguide';
import SubNavigation from '../../Header/SubNavigation';
import IdentityProviderSidebar from './Sidebar/IdentityProviderSidebar';
import './IdentityProviderContainer.scss';

function IdentityProviderContainer({
  className = '',
  setPanel,
  history,
}) {
  const qs = NavigationHelper.getParams() || {};

  /**
   * When the sidebar is closed
   */
  const onCloseSidebar = () => {
    const url = NavigationHelper.updateParams({
      identityProviderId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  const sidebar = (type, identityProviderId = null) => {
    setPanel({
      show: true,
      backdrop: type === 'new',
      width: 480,
      children: (
        <IdentityProviderSidebar
          identityProviderId={identityProviderId}
          isNew={type === 'new'}
        />
      ),
      onClose: onCloseSidebar,
    });
  };

  useEffect(() => {
    const isNew = qs.type === 'new';
    const isView = qs.identityProviderId && qs.type !== 'new';

    if (isNew || isView) {
      sidebar(qs.type, qs.identityProviderId);
    }
  }, [qs.type, qs.identityProviderId]);

  return (
    <div className={classNames('IdentityProviderContainer', className)}>
      <SubNavigation
        title="Identity Providers"
        buttons={[
          {
            text: 'New Identity Provider',
            icon: viAdd,
            userCan: [
              'identity_provider.create',
            ],
            color: 'primary',
            url: NavigationHelper.updateParams({
              type: 'new',
            }),
          },
        ]}
      />

      <TableIdentityProviders
        columns={[
          'Name',
          'App Provider Name',
          'App Client ID',
          'Domains',
          '...',
        ]}
        fetch={API.IdentityProvider.list}
        defaultSortBy={{
          label: 'Name',
          attr: 'name',
          direction: 'asc',
        }}
        paginator
        paginatorProps={{
          label: 'Identity Providers',
          urlPaging: true,
          urlFilters: true,
        }}
        toggle
        toggleProps={{
          label: 'Show Archived Identity Providers',
          tooltip: true,
        }}
        rowLink={{
          identityProviderId: '_id',
        }}
        menuItems={[
          { name: 'Archive', userCan: 'identity_provider.delete' },
        ]}
      />
    </div>
  );
}

IdentityProviderContainer.propTypes = {
  className: PropTypes.string,
};

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default withRouter(connect(null, mapDispatchToProps)(IdentityProviderContainer));
